import dashboardModule from './dashboard';
import usersModule from './users';
import librariesModule from './libraries';
import subscrtiptionsModule from './subscriptions';
import settingsModule from './settings';
import logsModule from './logs';
import organizationModule from './organization';
import { BackofficeRoute } from '../types/route.interfaces';
import { CurrentUserInfo } from '../hooks/useCurrentUser';

export interface Module {
  routes: BackofficeRoute[] | ((currentUser: CurrentUserInfo) => BackofficeRoute[]);
  reducers: any;
  middleware?: any;
}

const modules = {
  dashboardModule,
  organizationModule,

  usersModule,
  subscrtiptionsModule,
  librariesModule,
  settingsModule,
  logsModule,
};
export default modules;
export {
  dashboardModule,
  usersModule,
  organizationModule,
  subscrtiptionsModule,
  librariesModule,
  logsModule,
  settingsModule,
};
